import { useEffect, useRef } from 'react'

const useOutsideClick = (ref, callback) => {
    const startTarget = useRef(null)
    const isInsideModal = useRef(false)

    useEffect(() => {
        const handleMouseDown = (event) => {
            startTarget.current = event.target

            // Only proceed if we have a valid, mounted ref
            if (!ref.current || !document.contains(ref.current)) {
                isInsideModal.current = undefined
                return
            }

            // Check if the initial mousedown was inside the modal
            isInsideModal.current = ref.current.contains(event.target)
        }

        const handleMouseUp = (event) => {
            // Only proceed if we have a valid, mounted ref
            if (!ref.current || !document.contains(ref.current)) {
                return
            }

            // Check if this modal has the highest z-index (should be the active one)
            const currentModal = ref.current.closest('[data-overlay-mask]')
            if (currentModal) {
                const currentZIndex = parseInt(currentModal.style.zIndex || '2000', 10)
                const allModals = document.querySelectorAll('[data-overlay-mask]')
                let isHighestZIndex = true

                allModals.forEach(modal => {
                    const modalZIndex = parseInt(modal.style.zIndex || '2000', 10)
                    if (modalZIndex > currentZIndex) {
                        isHighestZIndex = false
                    }
                })

                if (!isHighestZIndex) {
                    return
                }
            }

            // If mousedown started inside the modal, don't trigger callback regardless of where mouseup occurs
            // This handles cases where DOM manipulation during animations moves elements
            if (isInsideModal.current === true) {
                return
            }

            // If isInsideModal is undefined, it means we didn't have a valid ref during mousedown
            if (isInsideModal.current === undefined) {
                return
            }

            // Traditional check for cases where mousedown was outside
            if (ref.current.contains(startTarget.current) || ref.current.contains(event.target)) {
                return
            }

            callback(event)
        }

        document.addEventListener('mousedown', handleMouseDown)
        document.addEventListener('mouseup', handleMouseUp)

        return () => {
            document.removeEventListener('mousedown', handleMouseDown)
            document.removeEventListener('mouseup', handleMouseUp)
        }
    }, [ref, callback])

    return () => { }
}

export default useOutsideClick


// if (event.type === 'mousemove' || event.type === 'touchmove') {
//     setIsDragging(true)
//   }

//   if (event.type === 'mouseup' || event.type === 'touchend') {
//     setTimeout(() => {
//       setIsDragging(false);
//     }, 100);

//   }
